var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-align-responsible"},[_c('span',{staticClass:"subtitle-2 grey--text"},[_vm._v(_vm._s(_vm.$t("text.produtor_grupo_selecionado")))]),_c('h3',{staticClass:"mb-4 mt-0"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }